import { useTranslation } from '@centric-os/helpers';
import * as yup from 'yup';
import { SitesLocalePrefix } from '../../../enums';

export default () => {
  const { translate } = useTranslation();
  const LOCALE_PREFIX = SitesLocalePrefix.SITES;

  const businessUnitSchema = yup.object({
    id: yup.string().nullable().optional(),
    name: yup.string().required(translate(`errorMessages.required`)),
    meta: yup.object({
      unit: yup
        .number()
        .transform((value) => (isNaN(value) ? undefined : value))
        .typeError(translate(`errorMessages.invalidNumber`))
        .required(translate(`errorMessages.required`)),
      jde_environment: yup.string().nullable(),
    }),
    market_place: yup.object({
      is: yup.object({
        enabled: yup.boolean().nullable(),
      }),
      label: yup
        .object()
        .nullable()
        .when(`is.enabled`, {
          is: true,
          then: yup.object({
            en: yup.string().required(translate(`errorMessages.required`)).nullable(),
            fr: yup.string().nullable(),
          }),
          otherwise: yup.object({
            en: yup.string().nullable().optional(),
            fr: yup.string().nullable().optional(),
          }),
        }),
      location_description: yup
        .object()
        .nullable()
        .when(`is.enabled`, {
          is: true,
          then: yup.object({
            en: yup.string().required(translate(`errorMessages.required`)),
            fr: yup.string().nullable(),
          }),
          otherwise: yup.object({
            en: yup.string().nullable().optional(),
            fr: yup.string().nullable().optional(),
          }),
        }),
      pickup_instruction: yup
        .object()
        .nullable()
        .when(`is.enabled`, {
          is: true,
          then: yup.object({
            en: yup
              .string()
              .required(translate(`errorMessages.required`))
              .max(200, translate(`errorMessages.max`, { count: 200 })),
            fr: yup
              .string()
              .nullable()
              .max(200, translate(`errorMessages.max`, { count: 200 })),
          }),
          otherwise: yup.object({
            en: yup
              .string()
              .nullable()
              .optional()
              .max(200, translate(`errorMessages.max`, { count: 200 })),
            fr: yup
              .string()
              .nullable()
              .optional()
              .max(200, translate(`errorMessages.max`, { count: 200 })),
          }),
        }),
      logo: yup.string().nullable(),
    }),
  });

  return {
    businessUnitSchema,
  };
};
